import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  translatedSuccessSummary: string;
  translatedSuccessDetails: string;
  translatedSuccessAddDetails: string;
  translatedSuccessEditDetails: string;
  translatedSuccessDeleteDetails: string;

  constructor(
    private messageService: MessageService,
    private translate: TranslateService,
  ) {}
  // @deprecated
  public createSucceded() {
    this.successMessage(
      this.translate.instant('message.success'),
      this.translate.instant('message.CREATE_PROCESS_SUCCESS'),
    );
  }
  // @deprecated
  public updateSucceded() {
    this.successMessage(
      this.translate.instant('message.success'),
      this.translate.instant('message.UPDATE_PROCESS_SUCCESS'),
    );
  }
  // @deprecated
  public deleteSucceded() {
    this.successMessage(
      this.translate.instant('message.success'),
      this.translate.instant('message.DELETE_PROCESS_SUCCESS'),
    );
  }
  // @deprecated
  public archiveSucceded() {
    this.successMessage(
      this.translate.instant('message.success'),
      this.translate.instant('message.ARCHIVE_PROCESS_SUCCESS'),
    );
  }
  // @deprecated
  public saveSucceded() {
    this.successMessage(
      this.translate.instant('message.success'),
      this.translate.instant('message.SAVE_PROCESS_SUCCESS'),
    );
  }
  // @deprecated
  public unknownError() {
    this.errorMessage(
      this.translate.instant('message.ERROR'),
      this.translate.instant('message.THERE_WAS_A_PROBLEM'),
    );
  }
  // @deprecated
  public publishSucceded() {
    this.successMessage(
      this.translate.instant('message.success'),
      this.translate.instant('message.PUBLISH_PROCESS_SUCCESS'),
    );
  }
  // @deprecated
  public activateSucceded() {
    this.successMessage(
      this.translate.instant('message.success'),
      this.translate.instant('message.ACTIVATE_PROCESS_SUCCESS'),
    );
  }
  // @deprecated
  sucessMessage(): void {
    this.translate.get('base.toast.success').subscribe((res) => {
      this.translatedSuccessSummary = res;
    });
    this.translate.get('base.toast.sucessMessageDetails').subscribe((res) => {
      this.translatedSuccessDetails = res;
    });
    this.messageService.add({
      severity: 'success',
      summary: this.translatedSuccessSummary,
      detail: this.translatedSuccessDetails,
    });
  }
  // @deprecated
  sucessAddingMessage(): void {
    this.translate.get('base.toast.success').subscribe((res) => {
      this.translatedSuccessSummary = res;
    });
    this.translate
      .get('base.toast.sucessAddingMessageDetails')
      .subscribe((res) => {
        this.translatedSuccessAddDetails = res;
      });
    this.messageService.add({
      severity: 'success',
      summary: this.translatedSuccessSummary,
      detail: this.translatedSuccessAddDetails,
    });
  }
  // @deprecated
  sucessAddingMessagee(keyParam): void {
    this.translate.get('base.toast.success').subscribe((res) => {
      this.translatedSuccessSummary = res;
    });
    this.translate
      .get('base.toast.sucessAddingMessageDetails')
      .subscribe((res) => {
        this.translatedSuccessAddDetails = res;
      });
    this.messageService.add({
      key: keyParam,
      severity: 'success',
      summary: this.translatedSuccessSummary,
      detail: this.translatedSuccessAddDetails,
    });
  }
  // @deprecated
  sucessEdittingMessage(keyParam = 'edit'): void {
    this.translate.get('base.toast.success').subscribe((res) => {
      this.translatedSuccessSummary = res;
    });
    this.translate
      .get('base.toast.sucessEditMessageDetails')
      .subscribe((res) => {
        this.translatedSuccessDeleteDetails = res;
      });
    this.messageService.add({
      severity: 'success',
      summary: this.translatedSuccessSummary,
      detail: this.translatedSuccessDeleteDetails,
    });
  }
  // @deprecated
  sucessDeleteMessage(keyParam = 'delete'): void {
    this.translate.get('base.toast.success').subscribe((res) => {
      this.translatedSuccessSummary = res;
    });
    this.translate
      .get('base.toast.sucessDeleteMessageDetails')
      .subscribe((res) => {
        this.translatedSuccessDeleteDetails = res;
      });
    this.messageService.add({
      severity: 'success',
      summary: this.translatedSuccessSummary,
      detail: this.translatedSuccessDeleteDetails,
      key: keyParam,
    });
  }

  // sucess Archieved Details
  // @deprecated
  sucessArchievedMessage(): void {
    this.translate.get('base.toast.success').subscribe((res) => {
      this.translatedSuccessSummary = res;
    });
    this.translate
      .get('base.toast.sucessArchievedMessageDetails')
      .subscribe((res) => {
        this.translatedSuccessDeleteDetails = res;
      });
    this.messageService.add({
      severity: 'success',
      summary: this.translatedSuccessSummary,
      detail: this.translatedSuccessDeleteDetails,
    });
  }
  // @deprecated
  successMessage(summaryParam = 'Success', detailParam): void {
    this.messageService.add({
      severity: 'success',
      summary: summaryParam,
      detail: detailParam,
    });
  }
  // @deprecated
  warningMessage(summaryParam = 'Warning', detailParam): void {
    this.messageService.add({
      severity: 'warn',
      summary: summaryParam,
      detail: detailParam,
    });
  }
  // @deprecated
  errorMessage(summaryParam = 'Error', detailParam): void {
    this.messageService.add({
      severity: 'error',
      summary: summaryParam,
      detail: this.translate.instant(detailParam),
    });
  }
  // @deprecated
  infoMessage(summaryParam = 'Info', detailParam): void {
    this.messageService.add({
      severity: 'info',
      summary: summaryParam,
      detail: detailParam,
    });
  }
  clear(): void {
    this.messageService.clear();
  }

  successfulMsg(detailParam, clearOthers = false, showTitle = true): void {
    if (clearOthers) {
      this.clear();
    }
    this.showBottomRightNotificationWith(
      'success',
      showTitle ? this.translate.instant('message.success') : '',
      detailParam,
    );
  }

  errorMsg(detailParam, clearOthers = false, showTitle = true): void {
    if (clearOthers) {
      this.clear();
    }
    this.showBottomRightNotificationWith(
      'error',
      showTitle ? this.translate.instant('message.ERROR') : '',
      detailParam,
    );
  }

  public deleteSuccessfullyMsg(detail = 'message.DELETE_PROCESS_SUCCESS') {
    this.showBottomRightNotificationWith(
      'success',
      this.translate.instant('message.success'),
      this.translate.instant(detail),
    );
  }

  public activateSuccessfullyMsg(detail = 'message.ACTIVATE_PROCESS_SUCCESS') {
    this.showBottomRightNotificationWith(
      'success',
      this.translate.instant('message.success'),
      this.translate.instant(detail),
    );
  }

  public updatedSuccessfullyMsg(detail = 'message.UPDATE_PROCESS_SUCCESS') {
    this.showBottomRightNotificationWith(
      'success',
      this.translate.instant('message.success'),
      this.translate.instant(detail),
    );
  }

  public archiveSuccessfullyMsg(detail = 'message.ARCHIVE_PROCESS_SUCCESS') {
    this.showBottomRightNotificationWith(
      'success',
      this.translate.instant('message.success'),
      this.translate.instant(detail),
    );
  }

  public createdSuccessfullyMsg(detail = 'message.CREATE_PROCESS_SUCCESS') {
    this.showBottomRightNotificationWith(
      'success',
      this.translate.instant('message.success'),
      this.translate.instant(detail),
    );
  }

  public unknownErrorMsg(detailParam?, clearOthers?, life?: number) {
    if (clearOthers) {
      this.clear();
    }
    this.showBottomRightNotificationWith(
      'error',
      this.translate.instant('message.ERROR'),
      this.translate.instant(detailParam || 'message.THERE_WAS_A_PROBLEM'),
      undefined,
      life,
    );
  }

  public exportOnBackgroundSuccess() {
    this.showBottomRightNotificationWith(
      'success',
      this.translate.instant('message.success'),
      this.translate.instant(
        'message.TEMPLATE_EXPORT_BACKGROUND_EXECUTED_SUCCESSFULLY',
      ),
    );
  }

  public userDeactivatedSuccess() {
    this.showBottomRightNotificationWith(
      'success',
      this.translate.instant('message.success'),
      this.translate.instant('message.DEACTIVATE_ACCESS_FOR_THIS_USER_DONE'),
    );
  }
  public userActivatedSuccess() {
    this.showBottomRightNotificationWith(
      'success',
      this.translate.instant('message.success'),
      this.translate.instant('message.ACTIVATE_ACCESS_FOR_THIS_USER_DONE'),
    );
  }

  public spaceDeactivatedSuccess() {
    this.showBottomRightNotificationWith(
      'success',
      this.translate.instant('message.success'),
      this.translate.instant('message.DEACTIVATE_SPACE_DONE'),
    );
  }
  public spaceActivatedSuccess() {
    this.showBottomRightNotificationWith(
      'success',
      this.translate.instant('message.success'),
      this.translate.instant('message.ACTIVATE_SPACE_DONE'),
    );
  }

  public spaceUserInterfaceDeactivatedSuccess() {
    this.showBottomRightNotificationWith(
      'success',
      this.translate.instant('message.success'),
      this.translate.instant('message.DEACTIVATE_SPACE_USER_INTERFACE_DONE'),
    );
  }
  public spaceUserInterfaceActivatedSuccess() {
    this.showBottomRightNotificationWith(
      'success',
      this.translate.instant('message.success'),
      this.translate.instant('message.ACTIVATE_SPACE_USER_INTERFACE_DONE'),
    );
  }

  warningMsg(detailParam, clearOthers = false, life?: number): void {
    if (clearOthers) {
      this.clear();
    }
    this.showBottomRightNotificationWith(
      'warn',
      this.translate.instant('message.warn'),
      this.translate.instant(detailParam),
      undefined,
      life,
    );
  }

  infoMsg(summary, details, styleClass?): void {
    this.showBottomRightNotificationWith(
      'info',
      this.translate.instant(summary),
      this.translate.instant(details),
      styleClass,
    );
  }

  /**
   * Show a message with a translated summary and detail.
   * @param options.severity The severity of the message.
   * @param options.summaryKey The translation key of the summary.
   * @param options.summaryInterpolateParams The interpolation params of the summary.
   * @param options.detailKey The translation key of the detail.
   * @param options.detailInterpolateParams The interpolation params of the detail.
   * @example
   * this.toastService.showMessage({
   *    severity: 'success',
   *    summaryKey: 'message.success',
   *    detailKey: 'message.CREATE_PROCESS_SUCCESS',
   *    detailInterpolateParams: { name: 'John' }
   *  });
   */
  showMessage(options: {
    severity: 'success' | 'info' | 'warn' | 'error';
    summaryKey: string;
    summaryInterpolateParams?: object;
    detailKey: string;
    detailInterpolateParams?: object;
  }) {
    this.messageService.add({
      key: 'bottom-right',
      severity: options.severity,
      summary: this.translate.instant(
        options.summaryKey,
        options.summaryInterpolateParams,
      ),
      detail: this.translate.instant(
        options.detailKey,
        options.detailInterpolateParams,
      ),
    });
  }

  showBottomRightNotificationWith(
    severity,
    summary,
    message,
    styleClass?,
    life?: number,
  ): void {
    this.messageService.add({
      key: 'bottom-right',
      severity,
      summary,
      detail: message,
      ...(!!life && { life }),
      ...(!!styleClass && { styleClass }),
    });
  }
}
